// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__lo4hG","spin":"Loader_spin__ciBVR"};